package com.evoapps.evoshift.domain.model

/** The day [date] (ISO) is closed (its daily record is locked): its figures are final. */
class DayClosedException(val date: String) : Exception("Day $date is closed")
